// extracted by mini-css-extract-plugin
export default {"title":"SeatingPlanScreen_title__QlrkO","mainDiv":"SeatingPlanScreen_mainDiv__dPsq0"};